<div class="container">
  <div>
    <img src="assets/images/logo-airlines-blue.svg" alt="Logo da Latam Azul">
  </div>

  <div class="crew-details_container">
    <app-crew-details [crew]="crewInfo"></app-crew-details>
  </div>

  @if (isDetailsOnlyView) {
    <div class="flow-form details-only">
      <div class="btn-container">
        <button class="btn btn-confirm" type="button" (click)="dialogRef.close()">
          Fechar
        </button>
      </div>
    </div>
  }

  <!-- PASO 1: Ingreso de email -->
  @if (showFirstAccessFlow && step === 1) {
    <div>
      <form [formGroup]="emailForm" class="flow-form">
        <h5 class="label">E-mail</h5>
        <span class="input-desc">
          {{ hasRegisteredEmail
          ? 'Confirme o e-mail para receber o código de validação.'
          : (allowsCustomEmailDomain
          ? 'Informe o e-mail que deseja utilizar para validação.'
          : 'Informe o seu e-mail corporativo para validação.') }}
        </span>
        <div class="email-field">
          <div class="email-card" [class.has-domain-selector]="hasMultipleCompanyDomains">
            <span class="email-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M4 7.5h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a1 1 0 0 1 1-1Z" />
                <path d="m4.5 8 7.5 5.5L19.5 8" />
              </svg>
            </span>
            <div class="input-box email-prefix-box">
              <input formControlName="emailPrefix" type="text"
                [placeholder]="allowsCustomEmailDomain ? 'e-mail@dominio.com' : 'e-mail'" autocomplete="off"
                autocapitalize="off" spellcheck="false" (keydown)="onEmailPrefixKeyDown($event)"
                (input)="onEmailPrefixInput($event)">
              </div>
              @if (!allowsCustomEmailDomain && companyDomains.length) {
                <div class="email-domain-box">
                  @if (hasMultipleCompanyDomains) {
                    <select class="domain-select"
                      formControlName="emailDomain" aria-label="Domínio do e-mail">
                      @for (domain of companyDomains; track domain) {
                        <option [value]="domain">{{ domain }}</option>
                      }
                    </select>
                  } @else {
                    <span class="domain-label">{{ companyDomain }}</span>
                  }
                </div>
              }
            </div>
            @if (submited && emailForm.controls.emailPrefix.errors?.required) {
              <app-error-form class="field-error">
                {{ allowsCustomEmailDomain ? 'Informe o e-mail.' : 'Informe o prefixo do e-mail.' }}
              </app-error-form>
            }
            @if (submited && emailForm.controls.emailPrefix.errors?.pattern) {
              <app-error-form class="field-error">
                Prefixo inválido. Use apenas letras, números e pontos.
              </app-error-form>
            }
            @if (submited && emailForm.controls.emailPrefix.errors?.email) {
              <app-error-form class="field-error">
                Informe um e-mail válido.
              </app-error-form>
            }
            @if (emailPrefixDomainAlert) {
              <app-error-form class="field-error">
                Não inclua &#64; nem o domínio. Informe apenas o prefixo do e-mail.
              </app-error-form>
            }
          </div>
          <p class="helper-text">
            {{ hasRegisteredEmail
            ? 'Se necessário, ajuste o e-mail antes de solicitar o código.'
            : (allowsCustomEmailDomain
            ? 'Você pode informar o e-mail com o domínio que preferir.'
            : 'Use o mesmo e-mail corporativo vinculado a sua companhia.') }}
          </p>
          <div class="btn-container">
            <button class="btn btn-confirm" type="button" [disabled]="!canValidateEmail" (click)="validateEmail()">
              {{ loading ? 'Enviando...' : 'Validar e-mail' }}
            </button>
          </div>
        </form>
      </div>
    }

    <!-- PASO 2: Validación del código OTP -->
    @if (showFirstAccessFlow && step === 2) {
      <div>
        <form [formGroup]="codeForm" class="flow-form">
          <h5 class="label">Código de verificação</h5>
          <span class="input-desc">
            Informe o código de 6 dígitos enviado para <strong>{{ emailFull }}</strong>.
          </span>
          <p class="time-note">O código é válido por 10 minutos.</p>
          <div class="otp-field">
            <div class="otp-group" (paste)="onOtpPaste($event)">
              @for (slot of otpSlots; track slot; let index = $index) {
                <input #otpInput class="otp-input" type="text"
                  inputmode="numeric" pattern="[0-9]*" maxlength="1"
                  [attr.autocomplete]="index === 0 ? 'one-time-code' : 'off'"
                  [attr.aria-label]="'Dígito ' + (index + 1) + ' do código'" (input)="onOtpInput(index, $event)"
                  (keydown)="onOtpKeyDown(index, $event)" (focus)="onOtpFocus($event)">
              }
            </div>
            @if (submited && codeForm.controls.verificationCode.errors?.required) {
              <app-error-form class="field-error"
                >
                Informe o código de verificação.
              </app-error-form>
            }
            @if (submited && (codeForm.controls.verificationCode.errors?.minlength || codeForm.controls.verificationCode.errors?.maxlength || codeForm.controls.verificationCode.errors?.pattern)) {
              <app-error-form class="field-error"
                >
                O código deve ter 6 dígitos numéricos.
              </app-error-form>
            }
          </div>
          <p class="secondary-action">
            Não recebeu o código?
            <button type="button" class="link-button" [disabled]="!canResendCode" (click)="resendCode()">
              {{ resendLoading ? 'Enviando...' : 'Reenviar código' }}
            </button>
          </p>
          @if (dialogMode !== 'mfa') {
            <p class="context-action">
              E-mail incorreto?
              <button type="button" class="link-button" [disabled]="loading || resendLoading" (click)="editEmail()">
                Alterar e-mail
              </button>
            </p>
          }
          <div class="btn-container">
            <button class="btn btn-confirm" type="button" [disabled]="loading || !canAcceptVerificationCode"
              (click)="validateCode()">
              {{ loading ? 'Validando...' : 'Aceitar' }}
            </button>
          </div>
        </form>
      </div>
    }

    <!-- PASO 3: Creación de contraseña -->
    @if (showFirstAccessFlow && step === 3) {
      <div>
        <form [formGroup]="passwordForm" (submit)="confirm()" class="flow-form">
          <h5 class="label">Senha</h5>
          <span class="input-desc">Crie uma nova senha de acesso para o Passelivre.</span>
          <div class="input-group">
            <div class="input-box">
              <input formControlName="newPassword" type="password" placeholder="Nova Senha">
              @if (submited && passwordForm.controls.newPassword.errors?.required) {
                <app-error-form>
                  Informe a Nova Senha.
                </app-error-form>
              }
              @if (submited && passwordForm.controls.newPassword.errors?.minlength) {
                <app-error-form>
                  A senha deve ter pelo menos 6 caracteres.
                </app-error-form>
              }
            </div>
            <div class="input-box">
              <input formControlName="confirmPassword" type="password" placeholder="Confirmar Senha">
              @if (submited && passwordForm.controls.confirmPassword.errors?.required) {
                <app-error-form>
                  Informe a Confirmação da Senha.
                </app-error-form>
              }
            </div>
          </div>
          @if (submited && passwordForm.errors?.passwordEquals) {
            <app-error-form>
              As senhas estão diferentes.
            </app-error-form>
          }
          <div class="btn-container">
            <button class="btn btn-confirm" type="submit" [disabled]="loading">
              {{ loading ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </form>
      </div>
    }
  </div>